import React from "react";
import { useLang } from "@/context/LanguageContext";

const SocialProof = () => {
  const { t } = useLang();
  return (
    <section data-testid="social-proof-section" className="border-y border-sand-soft">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="py-12 md:py-16 grid grid-cols-2 md:grid-cols-5 gap-y-10 md:gap-y-0">
          {t.proof.items.map((it, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className={`px-2 md:px-8 ${i !== 0 ? "md:border-l border-sand-soft" : ""}`}
            >
              <div className="font-display font-light text-4xl md:text-5xl text-maif tracking-tighter">
                {it.value}
              </div>
              <div className="eyebrow mt-3">{it.label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="overflow-hidden border-t border-sand-soft py-5">
        <div className="marquee text-xs md:text-sm tracking-[0.32em] text-maif-muted/70">
          {[0, 1].map((k) => (
            <span key={k} className="flex items-center gap-12">
              {t.proof.strip.split(" · ").map((s, idx) => (
                <span key={idx} className="flex items-center gap-12">
                  <span>{s}</span>
                  <span className="text-terracotta/60">✦</span>
                </span>
              ))}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
